import axios from 'axios';
import { getEnv } from '../config';

const API_URL = getEnv('REACT_APP_API_URL') || '';

export const memberAPI = {
    getMembers: (params) => axios.get(`${API_URL}/api/members`, { params }),
    getMember: (id) => axios.get(`${API_URL}/api/members/${id}`),
    createMember: (data) => axios.post(`${API_URL}/api/members`, data),
    updateMember: (id, data) => axios.put(`${API_URL}/api/members/${id}`, data),
    deleteMember: (id) => axios.delete(`${API_URL}/api/members/${id}`),
    importMembers: (data) => axios.post(`${API_URL}/api/members/import`, data),
    toggleStatus: (id, data) => axios.put(`${API_URL}/api/members/${id}/status`, data),
    migrateToLeader: (id, data) => axios.post(`${API_URL}/api/admin/members/${id}/migrate-to-leader`, data),
    getAllPrayerRequests: () => axios.get(`${API_URL}/api/prayer-requests`),
    getPrayerRequests: (memberId) => axios.get(`${API_URL}/api/members/${memberId}/prayer-requests`),
    createPrayerRequest: (memberId, data) => axios.post(`${API_URL}/api/members/${memberId}/prayer-requests`, data),
    updatePrayerRequest: (memberId, prId, data) => axios.put(`${API_URL}/api/members/${memberId}/prayer-requests/${prId}`, data),
    deletePrayerRequest: (memberId, prId) => axios.delete(`${API_URL}/api/members/${memberId}/prayer-requests/${prId}`),
    togglePrayerReaction: (memberId, prId) => axios.post(`${API_URL}/api/members/${memberId}/prayer-requests/${prId}/react`),
    prayerStreamUrl: () => {
        const token = localStorage.getItem('token');
        const base = API_URL || window.location.origin;
        return `${base}/api/prayer-requests/stream?token=${encodeURIComponent(token)}`;
    },
    uploadPhoto: (memberId, file) => {
        const formData = new FormData();
        formData.append('photo', file);
        return axios.post(`${API_URL}/api/members/${memberId}/photo`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },
};
